'use strict';

module.exports = /* @ngInject */ function ($resource, apiConfig) {
	return {
		search:
			$resource(
				apiConfig.$get().apiUrl + '/unite/search?q=:search&customer=:customer&supplier=:supplier&offset=:offset&limit=:limit:catalogId',
				{
					search: '@search',
					customer: '@customer',
					supplier: '@supplier',
					offset: '@offset',
					limit: '@limit',
					catalogId: '@catalogId'
				}
			)
	}
}
